export default "__VITE_ASSET__jpC7Wayl__"